import { render, staticRenderFns } from "./show-description.vue?vue&type=template&id=0d793b3c&scoped=true&"
import script from "./show-description.vue?vue&type=script&lang=js&"
export * from "./show-description.vue?vue&type=script&lang=js&"
import style0 from "./show-description.vue?vue&type=style&index=0&id=0d793b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d793b3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d793b3c')) {
      api.createRecord('0d793b3c', component.options)
    } else {
      api.reload('0d793b3c', component.options)
    }
    module.hot.accept("./show-description.vue?vue&type=template&id=0d793b3c&scoped=true&", function () {
      api.rerender('0d793b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/show-description.vue"
export default component.exports